var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Edit"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit",
    clipPath: "url(#clip-Edit)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19028",
    "data-name": "Path 19028",
    d: "M107.593,394.36c-.229-.118-.32-.25-.3-.434a.387.387,0,0,1,.34-.351,1.205,1.205,0,0,1,.185-.009H120.8c.038,0,.076,0,.114,0a.4.4,0,0,1,.406.331.388.388,0,0,1-.26.438.244.244,0,0,0-.035.024Z",
    transform: "translate(-106.309 -379.043)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19029",
    "data-name": "Path 19029",
    d: "M133.575,104.126a2.6,2.6,0,0,1-.773,1.8q-3.2,3.2-6.4,6.393a.631.631,0,0,1-.293.16c-1.221.272-2.443.537-3.665.8-.4.087-.647-.159-.56-.558.264-1.222.529-2.445.8-3.665a.664.664,0,0,1,.184-.294q2.759-2.777,5.525-5.548c.323-.324.64-.654.973-.967a2.5,2.5,0,0,1,4.08,1.165C133.513,103.645,133.535,103.888,133.575,104.126Zm-9.869,4.935,2.382,2.444,5.571-5.635-2.383-2.379Zm8.6-3.767a1.726,1.726,0,0,0-2.473-2.408Zm-8.983,4.623-.544,2.473,2.472-.545Z",
    transform: "translate(-120.196 -100.91)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.5c2f56ed7ea58a68e106fbd766059e2b.svg";
export { ForwardRef as ReactComponent };